import {z} from 'zod'

import {AspectRatioEnum, BlockKeyFactVisualizationEnum} from '@sdox/api'

import {i18nValidation} from '../../../../../'
import {optionalButtonSchema} from './buttonSchemas'

const keyFactBaseSchema = z.object({
  text: z.string().min(1, {message: i18nValidation.enterText}),
  title: z.string().min(1, {message: i18nValidation.enterText}),
  cta: optionalButtonSchema,
}).required()

const imageSchema =  z.object({
  // md5 hashes are actually 16 bytes long, but if the hash algorithm changes
  //  we would have a very hard-to-find bug if we expect a hard 16 chars.
  fileHash: z.string().min(1),
})

const keyFactBlockWithImageSchema = z.object({
  visualization: z.literal(BlockKeyFactVisualizationEnum.WithImage),
  aspectRatio: z.nativeEnum(AspectRatioEnum),
  items: z.array(keyFactBaseSchema.extend({
    image: imageSchema,
  })),
})

const keyFactBlockWithoutImageSchema = z.object({
  visualization: z.literal(BlockKeyFactVisualizationEnum.WithoutImage),
  aspectRatio: z.undefined(),
  items: z.array(keyFactBaseSchema.extend({
    image: z.undefined(),
  })),
})

export const keyFactBlockSchema = z.discriminatedUnion('visualization', [
  keyFactBlockWithImageSchema,
  keyFactBlockWithoutImageSchema,
])
